import { defineStore } from 'pinia';
import { readonly, ref, type Ref } from 'vue';

type TimerStore = {
    now: Readonly<Ref<Date>>,
    startTimer: (name: string) => void,
    destroyTimer: (name: string) => void,
};

export const useTimerStore = defineStore('timer', (): TimerStore => {
    const now = ref(new Date());
    const timers = ref<string[]>([]);
    const intervalId = ref<number | null>(null);

    const updateTime = () => {
        now.value = new Date();
    };

    const addTimer = (name: string) => {
        timers.value.push(name);
    };

    const removeTimer = (name: string) => {
        if (!timers.value.includes(name)) {
            return;
        }

        timers.value = timers.value.filter((timer) => timer !== name);
    };

    const startInterval = (callable: () => void) => {
        if (intervalId.value !== null) {
            return;
        }

        intervalId.value = window.setInterval(callable, 1000);
    };

    const clearTimerInterval = () => {
        if (intervalId.value === null) {
            return;
        }

        window.clearInterval(intervalId.value);
        intervalId.value = null;
    };

    const hasTimers = () => timers.value.length !== 0;

    const destroyTimer = (name: string) => {
        removeTimer(name);
        if (!hasTimers()) {
            clearTimerInterval();
        }
    };

    const startTimer = (name: string) => {
        addTimer(name);
        startInterval(updateTime);
    };

    return {
        now: readonly(now),
        startTimer,
        destroyTimer,
    };
});
